module.exports = __webpack_public_path__ + "static/media/[Philm]2010-07-17-3.532a6394.md";